import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import { convertBytes } from 'utils/helpers';
import TrashIcon from 'assets/icons/file-cabinet-trash/trash.svg';
import { styles } from './styles';

interface ITrashFolderListCard {
  name: string;
  size: number;
  itemsCount: number;
  onClick: () => void;
}

export const TrashFolderListCard = ({ name, size, itemsCount, onClick }: ITrashFolderListCard) => {
  return (
    <TableRow sx={styles.tableRow}>
      <TableCell sx={styles.tableCell} className="first">
        <Grid sx={styles.tableFirstCellContainer} onClick={onClick}>
          <TrashIcon />
          <Typography>{name}</Typography>
        </Grid>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>-</Typography>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>{convertBytes(Number(size), 2)}</Typography>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>
          <>
            {itemsCount || '0'} {itemsCount && Number(itemsCount) === 1 ? 'file' : 'files'}
          </>
        </Typography>
      </TableCell>
      <TableCell sx={styles.tableCell} className="actions-wrapper"></TableCell>
    </TableRow>
  );
};
